import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FamilyInviteSchema = withDefaults({
  type: 'family-invite',
  fields: [
    {
      kind: 'attribute',
      name: 'inviteCodeTypeId',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isValid',
    },
    {
      kind: 'belongsTo',
      name: 'family',
      type: 'family',
      options: {
        async: false,
        inverse: 'family',
      },
    },
  ],
});

export default FamilyInviteSchema;
